function hacerScroll(ancla) {
    if (ancla.length) {
        $('html, body').animate({
            scrollTop: $(ancla).offset().top - 90
        }, 1000);
    }
}
$('[data-menu="tabScroll"]').click(function (e) {
    var tab = $(this).attr('href');
    hacerScroll(tab);
    e.preventDefault();
});
$('[data-menu="tabMenuFiltro"]').click(function (e) {
    var tab = $(this).attr('href');
    $padre = $(tab).closest('.slider-marcas');
    $padre.find('.link-marca').removeClass('active');
    $(tab).addClass('active');
    $('*[data-marca]').removeClass('active');
    $('[data-marca="'+tab.replace('#','')+'"]').addClass('active');
    if (!$('#close-btn').prop( "checked")) $('#close-btn').prop( "checked", true );
    cargaSliderTabs('[data-marca="'+tab.replace('#','')+'"]');
    hacerScroll(tab);
    e.preventDefault();
});
$('.js-tab-marca').click(function () { 
    $padre = $(this).closest('.slider-marcas');
    $id = $(this).attr('id');
    $padre.find('.link-marca').removeClass('active');
    $(this).addClass('active');
    $('*[data-marca]').removeClass('active');
    $('[data-marca="'+$id+'"]').addClass('active');
    cargaSliderTabs('[data-marca="'+$id+'"]');
});
$('.js-sendBanner').click(function (e) { 

    var padre = $(this).closest('.c-hero-app');
    var m = $(padre).attr('data-title');
    var tab = $(padre).attr('data-tab');
    var p = $(padre).attr('data-position');

    dataLayer.push({
        'event': 'trackClickProm',
        'productos': [{
            'id': 'undefined',
            'name': m,
            'creative': m,
            'position': p,
        }],
    });
});
function cargaSliderTabs(tab) {
    cargarSliderBanner($(tab+' .slider-app'));
    cargarSliderApoyo($(tab+' .slider-app-apoyo'));
    cargarSliderApoyoMobile(tab+' .slider-app-apoyoMobile');
}
function sentInfoSlider(slick, currentSlide) {
    var slider = slick.$slider[0];
    var banner = $(slider).find('[data-slick-index="'+currentSlide+'"] .c-hero-app');
    if (!$(banner).hasClass('sendInfo-ok')) {
        var title = $(banner).attr('data-title');
        var tab = $(banner).attr('data-tab');
        dataLayer.push({
            'event': 'trackImpProm',
            'productos': [{
              'id': 'undefined',
              'name': title,
              'creative': title,
              'position': currentSlide,
             }],
        });     
        $(banner).addClass('sendInfo-ok');
        $(banner).attr('data-position',currentSlide);
    }
}
function cargarSliderBanner(slider) {
    if (!$(slider).hasClass('slick-initialized')) {
        $(slider).on('init', function(event, slick){
            sentInfoSlider(slick, 0);
        });
        $(slider).slick({
            dots: false,
            arrows: true, 
            pauseOnFocus: false, 
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1100,
            autoplay: true,
            autoplaySpeed: 11000,
            accessibility: false,
            nextArrow: '<button class="slick-next slick-arrow arrow-next"></button>',
            prevArrow: '<button class="slick-prev slick-arrow arrow-prev"></button>',
            responsive: [
                {
                    breakpoint: 550,
                    settings: {
                        arrows: false, 
                        slidesToShow: 1,
                    }
                },
            ]
        });
        $(slider).on('afterChange', function(event, slick, currentSlide){
            sentInfoSlider(slick, currentSlide);
        });
    }else{
        $(slider).slick('refresh');
    }
}
function cargarSliderApoyo(slider) {
    if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick({
            dots: false,
            arrows: true, 
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnFocus: false, 
            variableWidth: true,
            accessibility: false,
            nextArrow: '<button class="slick-next slick-arrow arrow-next"></button>',
            prevArrow: '<button class="slick-prev slick-arrow arrow-prev"></button>',
            responsive: [
                {
                    breakpoint: 550,
                    settings: {
                        arrows: false, 
                        slidesToShow: 1,
                    }
                },
            ]
        });
    }else{
        $(slider).slick('refresh');
    }
}
function cargarSliderApoyoMobile(slider) {
    if ($(window).width() >= 1070) {
        if ($(slider).hasClass('slick-initialized')) {
            $(slider).slick('unslick');
        }
        return false;
    }
    if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick({
            dots: false,
            arrows: true, 
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnFocus: false, 
            variableWidth: true,
            accessibility: false,
            nextArrow: '<button class="slick-next slick-arrow arrow-next"></button>',
            prevArrow: '<button class="slick-prev slick-arrow arrow-prev"></button>',
            responsive: [
                {
                    breakpoint: 550,
                    settings: {
                        arrows: false, 
                        slidesToShow: 1,
                    }
                },
            ]
        });
    }else{
        $(slider).slick('refresh');
    }
}
function countNoti() {
    var noti = $('.js-count-noti').length;
    $('.js-push-noti').append('<span class="bg-green text-white">'+noti+'</span>');
}
$(document).ready(function(){
    cargarSliderBanner($('#tab1 .slider-app')[0]);
    cargarSliderBanner($('[data-marca].active .slider-app'));
    cargarSliderApoyo('[data-marca].active .slider-app-apoyo');
    cargarSliderApoyoMobile('[data-marca].active .slider-app-apoyoMobile');
    $('.slider-marcas').slick({
        dots: false,
        arrows: true, 
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 7,
        pauseOnFocus: false, 
        accessibility: false,
        nextArrow: '<button class="slick-next slick-arrow arrow-next"></button>',
        prevArrow: '<button class="slick-prev slick-arrow arrow-prev"></button>',
        responsive: [
            {
                breakpoint: 950,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 650,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 550,
                settings: {
                    slidesToShow: 3,
                    arrows: false,
                }
            },
        ]
    });
});
$(window).on('resize',function () {
    cargarSliderApoyoMobile('[data-marca].active .slider-app-apoyoMobile');
});
$(window).on('load',function () {
    setTimeout(function(){
        countNoti();
    }, 5000);
});